/**
 * Helper function to add or remove class
 */
export const addOrRemoveHoverClass = function (element, add) {
  if (add) {
    $(element).parent('li').addClass('focus');
  } else {
    $(element).parent('li').removeClass('focus');
  }
};

/**
 * Uses the helper function to add the
 * class "focus" when the element is hovered
 *
 * Removed the "focus class" from the other elements
 */
export const onfocusAddClass = {
  bind: (el, binding, vnode) => {
    const context = vnode.context;

    const handler = function () {
      context.$emit('menuFocusHandler', el);
    };

    context.$on('menuFocusHandler', (focusElement) => {
      addOrRemoveHoverClass(el, focusElement === el);
    });

    el.addEventListener('focus', handler, true);
  },
};

/**
 * On focus of the mobile menu button
 * trigger a click to expand the menu
 */
export const onfocusTriggerClick = {
  bind: function bindElement(el) {
    el.addEventListener(
      'focus',
      () => {
        $(el).trigger('click');
      },
      true,
    );
  },
};

$(window).on('click', () => {
  $('li.focus').removeClass('focus');
});

/**
 * TEMP FIX FOR DEMO
 */
setTimeout(() => {
  $('.dropdown > a:not(.dropdown-toggle)').click(function () {
    if (document.body.clientWidth >= 992) {
      window.location.href = window.location.origin + $(this).attr('href');
    }
  });
}, 1000);
